import {useContext} from 'react'
import CheckoutVersionContext from '@providers/CheckoutVersionContext'

export default function useCheckoutVersion() {
  const version = useContext(CheckoutVersionContext)
  return version
}
